import Modal from "../ui-components/Modal";
import Select from "../ui-components/Select";
import Input from "../ui-components/Input";
import _ from "lodash";
import { useEffect, useState } from "react";
import Button from "../ui-components/Button";

const SpreadsheetOutputRangeModal = ({
  spreadsheetConfigurationObject,
  updateSpreadsheetConfiguration,
  selectedOutputRangeIndex,
  onExit
}) => {

  let sheetsOptions = spreadsheetConfigurationObject.sheets?.length ?
    spreadsheetConfigurationObject.sheets.map((s) => ({
      name: s,
      value: s
    })) : [{name: "", value: ""}];

  useEffect(() => {
    let firstSheet = spreadsheetConfigurationObject.sheets?.length ? spreadsheetConfigurationObject.sheets[0] : "";
    if (!spreadsheetConfigurationObject.output_ranges[selectedOutputRangeIndex]?.sheet) {
      updateSpreadsheetConfiguration({
        ...spreadsheetConfigurationObject,
        output_ranges: spreadsheetConfigurationObject.output_ranges.map((item, i) => {
          if (i === selectedOutputRangeIndex) {
            return {
              ...item,
              sheet: sheetsOptions[0]?.value,
            }
          } else {
            return item;
          }
        })
      });
    }
  }, []);

  return (
    <Modal
      onExit={onExit}
    >
      <Input
        label={"key"}
        value={spreadsheetConfigurationObject.output_ranges[selectedOutputRangeIndex]?.key || ""}
        onChange={(e) => {
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            output_ranges: spreadsheetConfigurationObject.output_ranges.map((item, i) => {
              if (i === selectedOutputRangeIndex) {
                return {
                  ...item,
                  key: e.target.value,
                }
              } else {
                return item;
              }
            })
          })
        }}
      />
      <Select
        label={"select sheet"}
        options={sheetsOptions}
        value={spreadsheetConfigurationObject.output_ranges[selectedOutputRangeIndex]?.sheet || null}
        onChange={(e) => {
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            output_ranges: spreadsheetConfigurationObject.output_ranges.map((item, i) => {
              if (i === selectedOutputRangeIndex) {
                return {
                  ...item,
                  sheet: e.target.value,
                }
              } else {
                return item;
              }
            })
          })
        }}
      />
      <Input
        label={"range"}
        value={spreadsheetConfigurationObject.output_ranges[selectedOutputRangeIndex]?.range || ""}
        onChange={(e) => {
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            output_ranges: spreadsheetConfigurationObject.output_ranges.map((item, i) => {
              if (i === selectedOutputRangeIndex) {
                return {
                  ...item,
                  range: e.target.value,
                }
              } else {
                return item;
              }
            })
          })
        }}
      />
      <Select
        label={"type"}
        options={[
          {name: "number", value: "number"},
          {name: "text", value: "text"}
        ]}
        value={spreadsheetConfigurationObject.output_ranges[selectedOutputRangeIndex]?.type || null}
        onChange={(e) => {
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            output_ranges: spreadsheetConfigurationObject.output_ranges.map((item, i) => {
              if (i === selectedOutputRangeIndex) {
                return {
                  ...item,
                  type: e.target.value,
                }
              } else {
                return item;
              }
            })
          })
        }}
      />
      <div className="mt-4 flex justify-end">
        <Button onClick={onExit}>DONE</Button>
      </div>
    </Modal>
  )
}

export default SpreadsheetOutputRangeModal;